var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.$store.state.loginStatus === false
        ? _c("div", [_c("FacebookLogin")], 1)
        : _c(
            "div",
            { staticClass: "installPage" },
            [
              _c("span", {
                domProps: {
                  innerHTML: _vm._s(_vm.$t("install_page.install_prompt")),
                },
              }),
              _c("span", {
                staticClass: "infoText",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("install_page.choose_page_info_text")
                  ),
                },
              }),
              _c("VSelectNoPointerScroll", {
                on: {
                  IsValid: function ($event) {
                    _vm.validSelect = true
                  },
                  IsNotValid: function ($event) {
                    _vm.validSelect = false
                  },
                },
              }),
              _c("span", {
                staticClass: "infoText",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("install_page.input_activation_code_info_text")
                  ),
                },
              }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.activationCode,
                    expression: "activationCode",
                  },
                ],
                class: { valid: _vm.validCode, invalid: !_vm.validCode },
                attrs: { id: "activationCode" },
                domProps: { value: _vm.activationCode },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.activationCode = $event.target.value
                  },
                },
              }),
              _c("div", { staticClass: "actionBar" }, [
                _vm.busy == true
                  ? _c(
                      "div",
                      {
                        staticClass: "keyloopButton",
                        attrs: { id: "activateBusy" },
                      },
                      [
                        _vm._v(_vm._s(_vm.$t("global.wait")) + "\n        "),
                        _c("span"),
                      ]
                    )
                  : _c("div", [
                      _c(
                        "button",
                        {
                          class: [
                            "textUppercase",
                            "keyloopButton",
                            { loading: _vm.busy },
                          ],
                          attrs: {
                            id: "activateButton",
                            disabled:
                              !_vm.validCode ||
                              !_vm.validSelect ||
                              _vm.busy == true,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.install()
                            },
                          },
                        },
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("install_page.add_page_button")
                              ),
                            },
                          }),
                        ]
                      ),
                    ]),
              ]),
            ],
            1
          ),
      _vm._l(_vm.errors, function (error) {
        return _c("div", { staticClass: "error py-2 mb-2" }, [
          _c("b", { domProps: { innerHTML: _vm._s(error.error) } }),
          _c("span", { domProps: { innerHTML: _vm._s(error.errorDetails) } }),
        ])
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }